export function getTotalNumberOfProspects(valid, existing, bad) {
    return (
        ((Array.isArray(valid) && valid.length) || 0) +
        ((Array.isArray(existing) && existing.length) || 0) +
        ((Array.isArray(bad) && bad.length) || 0)
    );
}
